export default __webpack_public_path__ + "static/media/back.431cbf63.png";